import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import LocalizedStrings from "react-localization";

let stringsOrder = new LocalizedStrings({
    ru: {
        'order': 'Заказать',
        'submitApplication': 'Оставьте заявку',
        'contactNextBusinessDay': 'Мы свяжемся с вами в ближайшее рабочее время',
        'phoneNumber': 'Номер телефона',
        'name': 'Имя',
        'send': 'Отправить',
        'confirmMessage': "Нажимая 'Отправить', Вы подтверждаете",
        'termsOfProcessing': 'условия обработки персональных данных',
    },
    et: {
        'order': 'Заказать',
        'submitApplication': 'Оставьте заявку',
        'contactNextBusinessDay': 'Мы свяжемся с вами в ближайшее рабочее время',
        'phoneNumber': 'Номер телефона',
        'name': 'Имя',
        'send': 'Отправить',
        'confirmMessage': "Нажимая 'Отправить', Вы подтверждаете",
        'termsOfProcessing': 'условия обработки персональных данных',
    }
});

const CreateOrderPopup = () => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    return (
        <div>
            <button className="btn bg-sky-500 hover:bg-sky-600 text-white font-semibold text-base py-2 px-4 rounded-3xl w-full h-12 sm:w-44 sm:text-xl" onClick={() => setIsPopupOpen(true)}>
                {stringsOrder.order}
            </button>

            {isPopupOpen && (
                <div className="fixed inset-0 flex justify-center items-center z-50">
                    <div className="fixed inset-0 bg-black opacity-50"></div>
                    <div className="bg-white sm:rounded-2xl rounded-none p-4 w-full h-full sm:p-2 sm:max-w-xl sm:max-h-96 z-50 relative">
                        <div className="flex flex-col items-center justify-start sm:justify-center h-full relative">
                            <img src="/images/popup-close.svg" alt="Popup close"
                                 className="absolute top-1 right-1 cursor-pointer w-10 h-10"
                                 onClick={() => setIsPopupOpen(false)}
                            />
                            <h2 className="text-2xl font-semibold mb-2 mt-16 sm:mt-5">{stringsOrder.submitApplication}</h2>
                            <p className="w-2/3 text-center text-base font-light mb-12 sm:mb-4 sm:w-2/4">
                                {stringsOrder.contactNextBusinessDay}
                            </p>
                            <div className="w-full sm:w-2/4 mb-2">
                                <input type="text"
                                       className="w-full h-10 rounded sm:rounded-lg border-gray-400 px-4 py-2 font-normal text-base placeholder-gray-400"
                                       placeholder={stringsOrder.phoneNumber}
                                />
                            </div>
                            <div className="w-full sm:w-2/4 sm:mb-4">
                                <input type="text"
                                       className="w-full h-10 rounded sm:rounded-lg border-gray-400 px-4 py-2 font-normal text-base placeholder-gray-400"
                                       placeholder={stringsOrder.name}
                                />
                            </div>
                            <button
                                className="bg-sky-500 hover:bg-sky-600 text-white font-semibold text-lg sm:text-base py-2 mt-0 h-14 w-full rounded-full absolute bottom-20 sm:static sm:mt-8 sm:w-36 sm:h-14 sm:px-4">
                                {stringsOrder.send}
                            </button>
                            <p className="text-center mb-3 mt-8 absolute bottom-6 w-full text-sm sm:static sm:mt-4 sm:w-2/4 sm:mb-1 sm:text-xs">
                                {stringsOrder.confirmMessage}
                            </p>
                            <p className="text-center mb-3 mt-3 text-sm w-full sm:w-2/4 sm:text-xs sm:mt-0 absolute bottom-0 sm:static ">
                                <a href="/police-cookies" className="underline text-blue-500 hover:text-blue-600">
                                    {stringsOrder.termsOfProcessing}
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

if (document.getElementById('create_order_button')) {
    ReactDOM.render(
        <CreateOrderPopup/>,
        document.getElementById('create_order_button')
    );
}
